import React, { useState } from 'react';
import { Button, Box, Typography, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../store/hooks';
import { login } from '../store/slices/authSlice';
import { directApi } from '../utils/direct-api';

const LoginTest: React.FC = () => {
  const [result, setResult] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const testLogin = async () => {
    setLoading(true);
    setResult('Test-Login wird ausgeführt...');
    
    try {
      const response = await directApi.login('admin@ordinationssoftware.at', 'admin123');
      
      if (response?.token && response?.user) {
        // Token speichern und Redux-State setzen (kein erneuter API-Call)
        dispatch(login.fulfilled({
          token: response.token,
          refreshToken: response.refreshToken || '',
          user: response.user,
          success: true,
          message: ''
        }, 'test-login', { email: 'admin@ordinationssoftware.at', password: 'admin123' }));
        setResult('Erfolgreich angemeldet – Weiterleitung zum Dashboard...');
        navigate('/dashboard', { replace: true });
      } else {
        setResult(`API-Antwort: ${JSON.stringify(response, null, 2)}`);
      }
    } catch (error: any) {
      console.error('Direct login error:', error);
      setResult(`Fehler: ${error.message || 'Unbekannter Fehler'}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Login Test
      </Typography>
      <Button 
        variant="contained" 
        onClick={testLogin} 
        disabled={loading}
        sx={{ mb: 2 }}
      >
        {loading ? 'Testing...' : 'Test Login'}
      </Button>
      
      {result && (
        <Alert severity={result.includes('Error') ? 'error' : 'success'}>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: '12px' }}>
            {result}
          </pre>
        </Alert>
      )}
    </Box>
  );
};

export default LoginTest;
